import { useEffect, useState } from "react";
import Modal from "react-modal";
import {
  getUserChannels,
  getVodServices,
} from "../../../services/vod/vod.service";

// Required for accessibility
Modal.setAppElement("#root");

export default function Videos({ videoChannel, handleBack }) {
  const [videoLoading, setVideoLoading] = useState(false);
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const fetchVideos = (id) => {
    setVideoLoading(true);
    getVodServices(id)
      .then((res) => {
        setVideoLoading(false);
        const rawVideos = res?.data?.data;
        if (Array.isArray(rawVideos) && rawVideos.length > 0) {
          setVideos(
            rawVideos.map((video) => ({
              ...video,
              tooltip_url: video.tooltip_url || null,
            }))
          );
        }
      })
      .catch(() => setVideoLoading(false));
  };

  useEffect(() => {
    if (videoChannel.id) {
      fetchVideos(videoChannel.id);
    }
  }, [videoChannel.id]);

  const openVideoModal = (video) => setSelectedVideo(video);
  const closeVideoModal = () => setSelectedVideo(null);

  return (
    <div>
      {/* Loading state */}
      {videoLoading && !videoChannel && (
        <div className="loading-wrapper">در حال بارگزاری اطلاعات</div>
      )}

      {/* Video list */}
      {videoChannel && videoChannel.id && !videoLoading && (
        <div>
          <div
            className="back-to-video-list"
            onClick={() => handleBack()}
            style={{ cursor: "pointer" }}
          >
            <div className="channel-title">
              نام کانال : {videoChannel?.channel?.title}
            </div>
            <div className="flex-item-back">
              <div>کانال ها</div>
              <div>
                <img src={"/images/svg/arrow-left.svg"} alt="بازگشت" />
              </div>
            </div>
          </div>

          <div className="videos-list">
            <div className="videos-item">
              {videos.map((video) => (
                <div
                  key={video.id}
                  className="videos-row"
                  onClick={() => openVideoModal(video)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="videos-row-content">
                    <div className="videos-row-image">
                      <img src={video.thumbnail_url} alt={video.description} />
                    </div>
                    <div className="videos-row-description">
                      {video.description}
                    </div>
                  </div>
                  <div className="videos-row-arrow">
                    <img src={"/images/svg/arrow-left.svg"} alt=">" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Video loading */}
      {videoChannel && videoChannel.id && videoLoading && (
        <div>ویدئو ها در حال بارگزاری است</div>
      )}

      {/* React Modal (always mounted) */}
      <Modal
        isOpen={!!selectedVideo}
        onRequestClose={closeVideoModal}
        className="ReactModal__Content"
        overlayClassName={{
          base: "ReactModal__Overlay",
          afterOpen: "ReactModal__Overlay--after-open",
          beforeClose: "ReactModal__Overlay--before-close",
        }}
        closeTimeoutMS={300}
      >
        {selectedVideo && (
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={closeVideoModal}
                >
                  &times;
                </button>
                <h4 className="modal-title">{selectedVideo.title}</h4>
              </div>
              <div className="modal-body" style={{ textAlign: "center" }}>
                <div className="video-wrapper">
                  <iframe
                    key={selectedVideo.id} // keep stable per video
                    src={selectedVideo.player_url}
                    title={selectedVideo.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="vod-title" style={{ marginTop: "1rem" }}>
                  {selectedVideo.description}
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
